import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';
import { formatDate } from '@/lib/catalog';

interface NewsPreviewProps {
  items: NewsItem[];
}

export default function NewsPreview({ items }: NewsPreviewProps) {
  if (items.length === 0) return null;

  const [lead, ...rest] = items;

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <Link
        to={`/news/${lead.id}`}
        className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100"
      >
        <div className="relative h-52 w-full overflow-hidden md:h-64">
          <img
            src={lead.cover}
            alt={lead.title}
            title={`${lead.title} - 影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-background-100/40 to-transparent" />
          <span className="absolute left-3 top-3 rounded bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {lead.category}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <p className="flex items-center gap-2 text-[11px] text-foreground-500">
            <span>{formatDate(lead.date)}</span>
            <span className="h-1 w-1 rounded-full bg-foreground-500/60" />
            <span>{lead.author}</span>
          </p>
          <h3 className="mt-2 line-clamp-2 text-base font-medium leading-7 text-foreground-900 transition-colors group-hover:text-primary-500 md:text-lg">
            {lead.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-xs leading-6 text-foreground-500 md:text-sm">{lead.excerpt}</p>
        </div>
      </Link>

      <div className="divide-y divide-background-200/80 rounded-lg border border-background-200 bg-background-100 px-4 md:px-5">
        {rest.map((item) => (
          <Link key={item.id} to={`/news/${item.id}`} className="group flex items-start gap-4 py-4 first:pt-5 last:pb-5">
            <span className="h-16 w-24 shrink-0 overflow-hidden rounded bg-background-200 sm:h-[72px] sm:w-28">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2 text-[11px] text-foreground-500">
                <span className="text-primary-500">{item.category}</span>
                <span className="h-1 w-1 rounded-full bg-foreground-500/60" />
                <span>{formatDate(item.date)}</span>
              </span>
              <span className="mt-1.5 line-clamp-2 block text-sm leading-6 text-foreground-900 transition-colors group-hover:text-primary-500">
                {item.title}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}